import { X } from "lucide-react";
import { useWizard } from "./wizardStore";

// The tour's last card is a different object from the step widget: bigger, centered, and the
// robot is the point. Keeping it here leaves the step widget's placement math alone.
export function WizardFinale({
  step,
  lastStep,
  text,
}: {
  step: number;
  lastStep: number;
  text: string;
}) {
  const vw = window.innerWidth;
  return (
    <div
      className="fixed z-pop w-[26rem] rounded-xl border-2 border-accent bg-surface p-6 text-center shadow-2xl"
      style={{ left: vw / 2 - 208, top: window.innerHeight / 2 - 140 }}
      data-testid="wizard-widget"
    >
      <style>{`
          @keyframes wiz-cheer { 0%,100% { transform: translateY(0) rotate(-8deg) } 25% { transform: translateY(-14px) rotate(8deg) } 50% { transform: translateY(0) rotate(-4deg) } 75% { transform: translateY(-8px) rotate(6deg) } }
          @keyframes wiz-confetti { 0% { transform: translateY(-6px) rotate(0deg); opacity: 0 } 15% { opacity: 1 } 100% { transform: translateY(46px) rotate(200deg); opacity: 0 } }
        `}</style>
      <div
        className="relative mx-auto h-20 w-56"
        aria-hidden
        data-testid="wizard-finale-robot"
      >
        <span
          className="absolute left-1/2 top-2 -translate-x-1/2 text-6xl"
          style={{ animation: "wiz-cheer 1.6s ease-in-out infinite" }}
        >
          🤖
        </span>
        {["✨", "🎉", "🎊", "✨", "🎉"].map((c, i) => (
          <span
            key={i}
            className="absolute top-0 text-lg"
            style={{
              left: `${8 + i * 22}%`,
              animation: `wiz-confetti 1.9s linear ${i * 0.35}s infinite`,
            }}
          >
            {c}
          </span>
        ))}
      </div>
      <div className="mt-2 flex items-start justify-between gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-accent">
          Genius Rx Demo/Tutorial · {step} / {lastStep}
        </span>
        <button
          onClick={() => useWizard.getState().exit()}
          className="rounded p-0.5 text-muted hover:bg-hover"
          aria-label="Exit wizard"
        >
          <X size={15} />
        </button>
      </div>
      <p className="mt-2 text-left text-[14px] leading-relaxed text-fg">
        {text}
      </p>
    </div>
  );
}
